import Helper from '@/utils/helper'

export default class ScreenSetting {
  constructor ({ id, width, scale, shrinkToFit, hideHeader }) {
    this.id = Helper.getValue(id)
    this.width = Helper.getValue(width)
    this.scale = Helper.getValue(scale)
    this.shrinkToFit = Helper.getValue(shrinkToFit)
    this.hideHeader = Helper.getValue(hideHeader)
  }

  getId () {
    return this.id
  }

  getWidth () {
    return this.width
  }

  getScale () {
    return this.scale
  }

  getShrinkToFit () {
    return this.shrinkToFit
  }

  getHideHeader () {
    return this.hideHeader
  }
}
